import { z } from 'zod';
const ServerLocationSchema = z.object({
    ip: z.string().nullish(),
    country: z.string().nullish(),
    region: z.string().nullish(),
    city: z.string().nullish(),
    lat: z.number().nullish(),
    lng: z.number().nullish(),
    postalCode: z.string().nullish(),
    timezone: z.string().nullish(),
    geonameId: z.number().nullish()
});
export const DomainInfoSchema = z.object({
    createdAt: z.string().nullish(),
    expiresAt: z.string().nullish(),
    updatedAt: z.string().nullish(),
    hostedCount: z.number().nullish(),
    serverLocation: ServerLocationSchema.nullish()
}).meta({
    id: 'DomainInfo'
});

//# sourceMappingURL=domain-info.schema.js.map